package flagpack.icons.medium

import androidx.compose.foundation.Image
import androidx.compose.foundation.layout.Box
import androidx.compose.foundation.layout.padding
import androidx.compose.runtime.Composable
import androidx.compose.ui.Modifier
import androidx.compose.ui.graphics.Color
import androidx.compose.ui.graphics.PathFillType
import androidx.compose.ui.graphics.SolidColor
import androidx.compose.ui.graphics.vector.ImageVector
import androidx.compose.ui.graphics.vector.PathData
import androidx.compose.ui.graphics.vector.group
import androidx.compose.ui.graphics.vector.path
import androidx.compose.ui.unit.dp
import flagpack.icons.FlagIcons
import org.jetbrains.compose.ui.tooling.preview.Preview

/**
 * Kazakhstan Flag (20x15dp)
 *
 * - ISO Alpha-2: KZ
 * - ISO Alpha-3: KAZ
 * - ISO Numeric: 398
 *
 * @see [Flagpack](https://flagpack.xyz)
 */
public val FlagIcons.Medium.Kazakhstan: ImageVector by lazy {
    ImageVector.Builder(
        name = "Kazakhstan:KZ:KAZ:398:Medium",
        defaultWidth = 20.dp,
        defaultHeight = 15.dp,
        viewportWidth = 20f,
        viewportHeight = 15f
    ).apply {
        group(
            clipPathData = PathData {
                moveTo(0f, 0f)
                horizontalLineToRelative(20f)
                verticalLineToRelative(15f)
                horizontalLineToRelative(-20f)
                close()
            }
        ) {
            path(fill = SolidColor(Color.White)) {
                moveTo(0f, 0f)
                horizontalLineToRelative(20f)
                verticalLineToRelative(15f)
                horizontalLineToRelative(-20f)
                close()
            }
            path(
                fill = SolidColor(Color(0xFF4EC7EE)),
                pathFillType = PathFillType.EvenOdd
            ) {
                moveTo(0f, 0f)
                verticalLineTo(15f)
                horizontalLineTo(20f)
                verticalLineTo(0f)
                horizontalLineTo(0f)
                close()
            }
        }
        group(
            clipPathData = PathData {
                moveTo(0f, 0f)
                verticalLineTo(15f)
                horizontalLineTo(20f)
                verticalLineTo(0f)
                horizontalLineTo(0f)
                close()
            }
        ) {
            path(fill = SolidColor(Color(0xFFFFE402))) {
                moveTo(2.556f, 14.523f)
                curveTo(2.517f, 14.817f, 2.705f, 15.026f, 3.02f, 15.161f)
                curveTo(3.445f, 15.342f, 3.873f, 15.172f, 4.267f, 14.736f)
                lineTo(3.756f, 14.275f)
                curveTo(3.581f, 14.469f, 3.455f, 14.544f, 3.357f, 14.542f)
                curveTo(3.548f, 14.406f, 3.793f, 14.238f, 4.091f, 14.037f)
                lineTo(4.235f, 13.83f)
                curveTo(4.35f, 13.337f, 3.992f, 13.07f, 3.447f, 13.07f)
                curveTo(3.126f, 13.07f, 2.869f, 13.133f, 2.706f, 13.27f)
                curveTo(2.439f, 13.494f, 2.484f, 13.852f, 2.766f, 14.038f)
                curveTo(2.788f, 14.053f, 2.811f, 14.067f, 2.834f, 14.078f)
                curveTo(2.676f, 14.212f, 2.58f, 14.35f, 2.556f, 14.523f)
                close()
            }
            path(
                stroke = SolidColor(Color(0xFFFFE402)),
                strokeLineWidth = 0.6875f
            ) {
                moveTo(2.853f, 14.06f)
                curveTo(2.853f, 14.06f, 2.931f, 13.887f, 2.892f, 13.797f)
            }
            path(fill = SolidColor(Color(0xFFFFE402))) {
                moveTo(5.356f, 14.523f)
                curveTo(5.396f, 14.817f, 5.207f, 15.026f, 4.892f, 15.161f)
                curveTo(4.467f, 15.342f, 4.039f, 15.172f, 3.645f, 14.736f)
                lineTo(4.156f, 14.275f)
                curveTo(4.331f, 14.469f, 4.457f, 14.544f, 4.555f, 14.542f)
                curveTo(4.364f, 14.406f, 4.119f, 14.238f, 3.821f, 14.037f)
                lineTo(3.678f, 13.83f)
                curveTo(3.563f, 13.337f, 3.92f, 13.07f, 4.465f, 13.07f)
                curveTo(4.786f, 13.07f, 5.043f, 13.133f, 5.206f, 13.27f)
                curveTo(5.473f, 13.494f, 5.428f, 13.852f, 5.146f, 14.038f)
                curveTo(5.124f, 14.053f, 5.101f, 14.067f, 5.078f, 14.078f)
                curveTo(5.236f, 14.212f, 5.332f, 14.35f, 5.356f, 14.523f)
                close()
            }
            path(fill = SolidColor(Color(0xFFFFE402))) {
                moveTo(5.372f, 13.918f)
                lineTo(4.746f, 14.201f)
                curveTo(4.658f, 14.006f, 4.631f, 13.829f, 4.705f, 13.66f)
                lineTo(5.335f, 13.934f)
                curveTo(5.357f, 13.885f, 5.356f, 13.883f, 5.372f, 13.918f)
                close()
            }
            path(fill = SolidColor(Color(0xFFFFE402))) {
                moveTo(2.556f, 0.477f)
                curveTo(2.517f, 0.183f, 2.705f, -0.026f, 3.02f, -0.161f)
                curveTo(3.445f, -0.342f, 3.873f, -0.172f, 4.267f, 0.264f)
                lineTo(3.756f, 0.725f)
                curveTo(3.581f, 0.531f, 3.455f, 0.456f, 3.357f, 0.457f)
                curveTo(3.548f, 0.594f, 3.793f, 0.763f, 4.091f, 0.963f)
                lineTo(4.235f, 1.17f)
                curveTo(4.35f, 1.663f, 3.992f, 1.93f, 3.447f, 1.93f)
                curveTo(3.126f, 1.93f, 2.869f, 1.867f, 2.706f, 1.73f)
                curveTo(2.439f, 1.506f, 2.484f, 1.148f, 2.766f, 0.961f)
                curveTo(2.788f, 0.947f, 2.811f, 0.933f, 2.834f, 0.922f)
                curveTo(2.676f, 0.788f, 2.58f, 0.65f, 2.556f, 0.477f)
                close()
            }
            path(fill = SolidColor(Color(0xFFFFE402))) {
                moveTo(5.356f, 0.477f)
                curveTo(5.396f, 0.183f, 5.207f, -0.026f, 4.892f, -0.161f)
                curveTo(4.467f, -0.342f, 4.039f, -0.172f, 3.645f, 0.264f)
                lineTo(4.156f, 0.725f)
                curveTo(4.331f, 0.531f, 4.457f, 0.456f, 4.555f, 0.457f)
                curveTo(4.364f, 0.594f, 4.119f, 0.763f, 3.821f, 0.963f)
                lineTo(3.678f, 1.17f)
                curveTo(3.563f, 1.663f, 3.92f, 1.93f, 4.465f, 1.93f)
                curveTo(4.786f, 1.93f, 5.043f, 1.867f, 5.206f, 1.73f)
                curveTo(5.473f, 1.506f, 5.428f, 1.148f, 5.146f, 0.961f)
                curveTo(5.124f, 0.947f, 5.101f, 0.933f, 5.078f, 0.922f)
                curveTo(5.236f, 0.788f, 5.332f, 0.65f, 5.356f, 0.477f)
                close()
            }
            path(
                fill = SolidColor(Color(0xFFFFE402)),
                pathFillType = PathFillType.EvenOdd
            ) {
                moveTo(3.184f, 12.539f)
                curveTo(2.789f, 12.551f, 2.544f, 12.632f, 2.544f, 13.012f)
                curveTo(2.544f, 13.432f, 2.951f, 13.563f, 3.384f, 13.563f)
                curveTo(3.777f, 13.563f, 4.219f, 13.319f, 4.219f, 12.883f)
                curveTo(4.219f, 12.617f, 3.882f, 12.082f, 3.032f, 10.921f)
                curveTo(3.002f, 10.893f, 2.986f, 10.879f, 2.973f, 10.879f)
                curveTo(3.025f, 10.851f, 3.116f, 10.817f, 3.235f, 10.817f)
                curveTo(3.277f, 10.817f, 3.331f, 10.838f, 3.384f, 10.865f)
                verticalLineTo(11.32f)
                horizontalLineTo(4.284f)
                verticalLineTo(10.976f)
                curveTo(4.284f, 10.588f, 3.71f, 10.129f, 3.235f, 10.129f)
                curveTo(2.821f, 10.129f, 2.488f, 10.327f, 2.319f, 10.61f)
                curveTo(2.153f, 10.891f, 2.28f, 11.16f, 2.519f, 11.374f)
                curveTo(2.875f, 11.865f, 3.152f, 12.271f, 3.325f, 12.539f)
                curveTo(3.261f, 12.538f, 3.227f, 12.538f, 3.184f, 12.539f)
                close()
                moveTo(3.226f, 12.856f)
                curveTo(3.213f, 12.854f, 3.201f, 12.851f, 3.19f, 12.847f)
                curveTo(3.199f, 12.856f, 3.231f, 12.895f, 3.231f, 13.012f)
                curveTo(3.231f, 13.076f, 3.228f, 13.121f, 3.224f, 13.152f)
                curveTo(3.108f, 13.05f, 3.076f, 12.872f, 3.161f, 12.734f)
                lineTo(3.163f, 12.731f)
                lineTo(3.15f, 12.705f)
                curveTo(3.151f, 12.704f, 3.153f, 12.703f, 3.155f, 12.703f)
                curveTo(3.175f, 12.692f, 3.191f, 12.684f, 3.163f, 12.731f)
                lineTo(3.226f, 12.856f)
                close()
                moveTo(3.19f, 12.847f)
                lineTo(3.178f, 12.844f)
                curveTo(3.18f, 12.844f, 3.181f, 12.845f, 3.183f, 12.846f)
                lineTo(3.19f, 12.847f)
                close()
                moveTo(3.532f, 12.883f)
                curveTo(3.532f, 12.871f, 3.528f, 12.864f, 3.521f, 12.86f)
                lineTo(3.525f, 12.865f)
                curveTo(3.529f, 12.874f, 3.532f, 12.88f, 3.532f, 12.883f)
                close()
            }
            path(
                fill = SolidColor(Color(0xFFFFE402)),
                pathFillType = PathFillType.EvenOdd
            ) {
                moveTo(4.728f, 12.539f)
                curveTo(5.123f, 12.551f, 5.368f, 12.632f, 5.368f, 13.012f)
                curveTo(5.368f, 13.432f, 4.961f, 13.563f, 4.528f, 13.563f)
                curveTo(4.135f, 13.563f, 3.693f, 13.319f, 3.693f, 12.883f)
                curveTo(3.693f, 12.617f, 4.03f, 12.082f, 4.88f, 10.921f)
                curveTo(4.91f, 10.893f, 4.926f, 10.879f, 4.939f, 10.879f)
                curveTo(4.887f, 10.851f, 4.797f, 10.817f, 4.677f, 10.817f)
                curveTo(4.635f, 10.817f, 4.581f, 10.838f, 4.528f, 10.865f)
                verticalLineTo(11.32f)
                horizontalLineTo(3.628f)
                verticalLineTo(10.976f)
                curveTo(3.628f, 10.588f, 4.202f, 10.129f, 4.677f, 10.129f)
                curveTo(5.091f, 10.129f, 5.424f, 10.327f, 5.593f, 10.61f)
                curveTo(5.759f, 10.891f, 5.632f, 11.16f, 5.393f, 11.374f)
                curveTo(5.037f, 11.865f, 4.76f, 12.271f, 4.587f, 12.539f)
                curveTo(4.651f, 12.538f, 4.686f, 12.538f, 4.728f, 12.539f)
                close()
                moveTo(4.686f, 12.856f)
                curveTo(4.699f, 12.854f, 4.711f, 12.851f, 4.722f, 12.847f)
                curveTo(4.714f, 12.856f, 4.681f, 12.895f, 4.681f, 13.012f)
                curveTo(4.681f, 13.076f, 4.684f, 13.121f, 4.688f, 13.152f)
                curveTo(4.804f, 13.05f, 4.836f, 12.872f, 4.751f, 12.734f)
                lineTo(4.749f, 12.731f)
                lineTo(4.762f, 12.705f)
                curveTo(4.761f, 12.704f, 4.759f, 12.703f, 4.757f, 12.703f)
                curveTo(4.737f, 12.692f, 4.721f, 12.684f, 4.749f, 12.731f)
                lineTo(4.686f, 12.856f)
                close()
                moveTo(4.722f, 12.847f)
                lineTo(4.734f, 12.844f)
                curveTo(4.733f, 12.844f, 4.731f, 12.845f, 4.729f, 12.846f)
                lineTo(4.722f, 12.847f)
                close()
                moveTo(4.38f, 12.883f)
                curveTo(4.38f, 12.871f, 4.384f, 12.864f, 4.391f, 12.86f)
                lineTo(4.387f, 12.865f)
                curveTo(4.383f, 12.874f, 4.38f, 12.88f, 4.38f, 12.883f)
                close()
            }
            path(
                fill = SolidColor(Color(0xFFFFE402)),
                pathFillType = PathFillType.EvenOdd
            ) {
                moveTo(3.184f, 8.347f)
                curveTo(2.789f, 8.335f, 2.544f, 8.254f, 2.544f, 7.874f)
                curveTo(2.544f, 7.455f, 2.951f, 7.323f, 3.384f, 7.323f)
                curveTo(3.777f, 7.323f, 4.219f, 7.567f, 4.219f, 8.003f)
                curveTo(4.219f, 8.269f, 3.882f, 8.804f, 3.032f, 9.965f)
                curveTo(3.002f, 9.993f, 2.986f, 10.007f, 2.973f, 10.007f)
                curveTo(3.025f, 10.036f, 3.116f, 10.069f, 3.235f, 10.069f)
                curveTo(3.277f, 10.069f, 3.331f, 10.048f, 3.384f, 10.021f)
                verticalLineTo(9.566f)
                horizontalLineTo(4.284f)
                verticalLineTo(9.91f)
                curveTo(4.284f, 10.298f, 3.71f, 10.757f, 3.235f, 10.757f)
                curveTo(2.821f, 10.757f, 2.488f, 10.559f, 2.319f, 10.276f)
                curveTo(2.153f, 9.995f, 2.28f, 9.726f, 2.519f, 9.512f)
                curveTo(2.875f, 9.021f, 3.152f, 8.615f, 3.325f, 8.347f)
                curveTo(3.261f, 8.348f, 3.227f, 8.348f, 3.184f, 8.347f)
                close()
                moveTo(3.226f, 8.03f)
                curveTo(3.213f, 8.032f, 3.201f, 8.036f, 3.19f, 8.039f)
                curveTo(3.199f, 8.03f, 3.231f, 7.991f, 3.231f, 7.874f)
                curveTo(3.231f, 7.81f, 3.228f, 7.765f, 3.224f, 7.734f)
                curveTo(3.108f, 7.836f, 3.076f, 8.014f, 3.161f, 8.152f)
                lineTo(3.163f, 8.155f)
                lineTo(3.15f, 8.181f)
                curveTo(3.151f, 8.182f, 3.153f, 8.183f, 3.155f, 8.183f)
                curveTo(3.175f, 8.194f, 3.191f, 8.202f, 3.163f, 8.155f)
                lineTo(3.226f, 8.03f)
                close()
                moveTo(3.19f, 8.039f)
                lineTo(3.178f, 8.042f)
                curveTo(3.18f, 8.042f, 3.181f, 8.041f, 3.183f, 8.04f)
                lineTo(3.19f, 8.039f)
                close()
                moveTo(3.532f, 8.003f)
                curveTo(3.532f, 8.015f, 3.528f, 8.022f, 3.521f, 8.026f)
                lineTo(3.525f, 8.021f)
                curveTo(3.529f, 8.012f, 3.532f, 8.006f, 3.532f, 8.003f)
                close()
            }
            path(
                fill = SolidColor(Color(0xFFFFE402)),
                pathFillType = PathFillType.EvenOdd
            ) {
                moveTo(4.728f, 8.347f)
                curveTo(5.123f, 8.335f, 5.368f, 8.254f, 5.368f, 7.874f)
                curveTo(5.368f, 7.455f, 4.961f, 7.323f, 4.528f, 7.323f)
                curveTo(4.135f, 7.323f, 3.693f, 7.567f, 3.693f, 8.003f)
                curveTo(3.693f, 8.269f, 4.03f, 8.804f, 4.88f, 9.965f)
                curveTo(4.91f, 9.993f, 4.926f, 10.007f, 4.939f, 10.007f)
                curveTo(4.887f, 10.036f, 4.797f, 10.069f, 4.677f, 10.069f)
                curveTo(4.635f, 10.069f, 4.581f, 10.048f, 4.528f, 10.021f)
                verticalLineTo(9.566f)
                horizontalLineTo(3.628f)
                verticalLineTo(9.91f)
                curveTo(3.628f, 10.298f, 4.202f, 10.757f, 4.677f, 10.757f)
                curveTo(5.091f, 10.757f, 5.424f, 10.559f, 5.593f, 10.276f)
                curveTo(5.759f, 9.995f, 5.632f, 9.726f, 5.393f, 9.512f)
                curveTo(5.037f, 9.021f, 4.76f, 8.615f, 4.587f, 8.347f)
                curveTo(4.651f, 8.348f, 4.686f, 8.348f, 4.728f, 8.347f)
                close()
                moveTo(4.686f, 8.03f)
                curveTo(4.699f, 8.032f, 4.711f, 8.036f, 4.722f, 8.039f)
                curveTo(4.714f, 8.03f, 4.681f, 7.991f, 4.681f, 7.874f)
                curveTo(4.681f, 7.81f, 4.684f, 7.765f, 4.688f, 7.734f)
                curveTo(4.804f, 7.836f, 4.836f, 8.014f, 4.751f, 8.152f)
                lineTo(4.749f, 8.155f)
                lineTo(4.762f, 8.181f)
                curveTo(4.761f, 8.182f, 4.759f, 8.183f, 4.757f, 8.183f)
                curveTo(4.737f, 8.194f, 4.721f, 8.202f, 4.749f, 8.155f)
                lineTo(4.686f, 8.03f)
                close()
                moveTo(4.722f, 8.039f)
                lineTo(4.734f, 8.042f)
                curveTo(4.733f, 8.042f, 4.731f, 8.041f, 4.729f, 8.04f)
                lineTo(4.722f, 8.039f)
                close()
                moveTo(4.38f, 8.003f)
                curveTo(4.38f, 8.015f, 4.384f, 8.022f, 4.391f, 8.026f)
                lineTo(4.387f, 8.021f)
                curveTo(4.383f, 8.012f, 4.38f, 8.006f, 4.38f, 8.003f)
                close()
            }
            path(
                fill = SolidColor(Color(0xFFFFE402)),
                pathFillType = PathFillType.EvenOdd
            ) {
                moveTo(3.184f, 6.653f)
                curveTo(2.789f, 6.665f, 2.544f, 6.746f, 2.544f, 7.126f)
                curveTo(2.544f, 7.545f, 2.951f, 7.677f, 3.384f, 7.677f)
                curveTo(3.777f, 7.677f, 4.219f, 7.433f, 4.219f, 6.997f)
                curveTo(4.219f, 6.731f, 3.882f, 6.196f, 3.032f, 5.035f)
                curveTo(3.002f, 5.007f, 2.986f, 4.993f, 2.973f, 4.993f)
                curveTo(3.025f, 4.964f, 3.116f, 4.931f, 3.235f, 4.931f)
                curveTo(3.277f, 4.931f, 3.331f, 4.952f, 3.384f, 4.979f)
                verticalLineTo(5.434f)
                horizontalLineTo(4.284f)
                verticalLineTo(5.09f)
                curveTo(4.284f, 4.702f, 3.71f, 4.243f, 3.235f, 4.243f)
                curveTo(2.821f, 4.243f, 2.488f, 4.44f, 2.319f, 4.724f)
                curveTo(2.153f, 5.005f, 2.28f, 5.274f, 2.519f, 5.488f)
                curveTo(2.875f, 5.979f, 3.152f, 6.385f, 3.325f, 6.653f)
                curveTo(3.261f, 6.652f, 3.227f, 6.652f, 3.184f, 6.653f)
                close()
                moveTo(3.226f, 6.97f)
                curveTo(3.213f, 6.968f, 3.201f, 6.964f, 3.19f, 6.961f)
                curveTo(3.199f, 6.97f, 3.231f, 7.009f, 3.231f, 7.126f)
                curveTo(3.231f, 7.19f, 3.228f, 7.235f, 3.224f, 7.266f)
                curveTo(3.108f, 7.164f, 3.076f, 6.986f, 3.161f, 6.848f)
                lineTo(3.163f, 6.845f)
                lineTo(3.15f, 6.819f)
                curveTo(3.151f, 6.818f, 3.153f, 6.817f, 3.155f, 6.817f)
                curveTo(3.175f, 6.806f, 3.191f, 6.798f, 3.163f, 6.845f)
                lineTo(3.226f, 6.97f)
                close()
                moveTo(3.19f, 6.961f)
                lineTo(3.178f, 6.958f)
                curveTo(3.18f, 6.958f, 3.181f, 6.959f, 3.183f, 6.96f)
                lineTo(3.19f, 6.961f)
                close()
                moveTo(3.532f, 6.997f)
                curveTo(3.532f, 6.985f, 3.528f, 6.978f, 3.521f, 6.974f)
                lineTo(3.525f, 6.979f)
                curveTo(3.529f, 6.988f, 3.532f, 6.994f, 3.532f, 6.997f)
                close()
            }
            path(
                fill = SolidColor(Color(0xFFFFE402)),
                pathFillType = PathFillType.EvenOdd
            ) {
                moveTo(4.728f, 6.653f)
                curveTo(5.123f, 6.665f, 5.368f, 6.746f, 5.368f, 7.126f)
                curveTo(5.368f, 7.545f, 4.961f, 7.677f, 4.528f, 7.677f)
                curveTo(4.135f, 7.677f, 3.693f, 7.433f, 3.693f, 6.997f)
                curveTo(3.693f, 6.731f, 4.03f, 6.196f, 4.88f, 5.035f)
                curveTo(4.91f, 5.007f, 4.926f, 4.993f, 4.939f, 4.993f)
                curveTo(4.887f, 4.964f, 4.797f, 4.931f, 4.677f, 4.931f)
                curveTo(4.635f, 4.931f, 4.581f, 4.952f, 4.528f, 4.979f)
                verticalLineTo(5.434f)
                horizontalLineTo(3.628f)
                verticalLineTo(5.09f)
                curveTo(3.628f, 4.702f, 4.202f, 4.243f, 4.677f, 4.243f)
                curveTo(5.091f, 4.243f, 5.424f, 4.44f, 5.593f, 4.724f)
                curveTo(5.759f, 5.005f, 5.632f, 5.274f, 5.393f, 5.488f)
                curveTo(5.037f, 5.979f, 4.76f, 6.385f, 4.587f, 6.653f)
                curveTo(4.651f, 6.652f, 4.686f, 6.652f, 4.728f, 6.653f)
                close()
                moveTo(4.686f, 6.97f)
                curveTo(4.699f, 6.968f, 4.711f, 6.964f, 4.722f, 6.961f)
                curveTo(4.714f, 6.97f, 4.681f, 7.009f, 4.681f, 7.126f)
                curveTo(4.681f, 7.19f, 4.684f, 7.235f, 4.688f, 7.266f)
                curveTo(4.804f, 7.164f, 4.836f, 6.986f, 4.751f, 6.848f)
                lineTo(4.749f, 6.845f)
                lineTo(4.762f, 6.819f)
                curveTo(4.761f, 6.818f, 4.759f, 6.817f, 4.757f, 6.817f)
                curveTo(4.737f, 6.806f, 4.721f, 6.798f, 4.749f, 6.845f)
                lineTo(4.686f, 6.97f)
                close()
                moveTo(4.722f, 6.961f)
                lineTo(4.734f, 6.958f)
                curveTo(4.733f, 6.958f, 4.731f, 6.959f, 4.729f, 6.96f)
                lineTo(4.722f, 6.961f)
                close()
                moveTo(4.38f, 6.997f)
                curveTo(4.38f, 6.985f, 4.384f, 6.978f, 4.391f, 6.974f)
                lineTo(4.387f, 6.979f)
                curveTo(4.383f, 6.988f, 4.38f, 6.994f, 4.38f, 6.997f)
                close()
            }
            path(
                fill = SolidColor(Color(0xFFFFE402)),
                pathFillType = PathFillType.EvenOdd
            ) {
                moveTo(3.184f, 2.461f)
                curveTo(2.789f, 2.449f, 2.544f, 2.368f, 2.544f, 1.988f)
                curveTo(2.544f, 1.569f, 2.951f, 1.437f, 3.384f, 1.437f)
                curveTo(3.777f, 1.437f, 4.219f, 1.681f, 4.219f, 2.117f)
                curveTo(4.219f, 2.383f, 3.882f, 2.918f, 3.032f, 4.079f)
                curveTo(3.002f, 4.107f, 2.986f, 4.121f, 2.973f, 4.121f)
                curveTo(3.025f, 4.15f, 3.116f, 4.183f, 3.235f, 4.183f)
                curveTo(3.277f, 4.183f, 3.331f, 4.162f, 3.384f, 4.135f)
                verticalLineTo(3.68f)
                horizontalLineTo(4.284f)
                verticalLineTo(4.024f)
                curveTo(4.284f, 4.412f, 3.71f, 4.871f, 3.235f, 4.871f)
                curveTo(2.821f, 4.871f, 2.488f, 4.673f, 2.319f, 4.39f)
                curveTo(2.153f, 4.109f, 2.28f, 3.84f, 2.519f, 3.626f)
                curveTo(2.875f, 3.135f, 3.152f, 2.728f, 3.325f, 2.461f)
                curveTo(3.261f, 2.462f, 3.227f, 2.462f, 3.184f, 2.461f)
                close()
                moveTo(3.226f, 2.144f)
                curveTo(3.213f, 2.146f, 3.201f, 2.149f, 3.19f, 2.153f)
                curveTo(3.199f, 2.144f, 3.231f, 2.105f, 3.231f, 1.988f)
                curveTo(3.231f, 1.924f, 3.228f, 1.879f, 3.224f, 1.848f)
                curveTo(3.108f, 1.95f, 3.076f, 2.128f, 3.161f, 2.266f)
                lineTo(3.163f, 2.269f)
                lineTo(3.15f, 2.295f)
                curveTo(3.151f, 2.296f, 3.153f, 2.297f, 3.155f, 2.297f)
                curveTo(3.175f, 2.308f, 3.191f, 2.316f, 3.163f, 2.269f)
                lineTo(3.226f, 2.144f)
                close()
                moveTo(3.19f, 2.153f)
                lineTo(3.178f, 2.156f)
                curveTo(3.18f, 2.156f, 3.181f, 2.155f, 3.183f, 2.154f)
                lineTo(3.19f, 2.153f)
                close()
                moveTo(3.532f, 2.117f)
                curveTo(3.532f, 2.129f, 3.528f, 2.136f, 3.521f, 2.14f)
                lineTo(3.525f, 2.135f)
                curveTo(3.529f, 2.126f, 3.532f, 2.12f, 3.532f, 2.117f)
                close()
            }
            path(
                fill = SolidColor(Color(0xFFFFE402)),
                pathFillType = PathFillType.EvenOdd
            ) {
                moveTo(4.728f, 2.461f)
                curveTo(5.123f, 2.449f, 5.368f, 2.368f, 5.368f, 1.988f)
                curveTo(5.368f, 1.569f, 4.961f, 1.437f, 4.528f, 1.437f)
                curveTo(4.135f, 1.437f, 3.693f, 1.681f, 3.693f, 2.117f)
                curveTo(3.693f, 2.383f, 4.03f, 2.918f, 4.88f, 4.079f)
                curveTo(4.91f, 4.107f, 4.926f, 4.121f, 4.939f, 4.121f)
                curveTo(4.887f, 4.15f, 4.797f, 4.183f, 4.677f, 4.183f)
                curveTo(4.635f, 4.183f, 4.581f, 4.162f, 4.528f, 4.135f)
                verticalLineTo(3.68f)
                horizontalLineTo(3.628f)
                verticalLineTo(4.024f)
                curveTo(3.628f, 4.412f, 4.202f, 4.871f, 4.677f, 4.871f)
                curveTo(5.091f, 4.871f, 5.424f, 4.673f, 5.593f, 4.39f)
                curveTo(5.759f, 4.109f, 5.632f, 3.84f, 5.393f, 3.626f)
                curveTo(5.037f, 3.135f, 4.76f, 2.728f, 4.587f, 2.461f)
                curveTo(4.651f, 2.462f, 4.686f, 2.462f, 4.728f, 2.461f)
                close()
                moveTo(4.686f, 2.144f)
                curveTo(4.699f, 2.146f, 4.711f, 2.149f, 4.722f, 2.153f)
                curveTo(4.714f, 2.144f, 4.681f, 2.105f, 4.681f, 1.988f)
                curveTo(4.681f, 1.924f, 4.684f, 1.879f, 4.688f, 1.848f)
                curveTo(4.804f, 1.95f, 4.836f, 2.128f, 4.751f, 2.266f)
                lineTo(4.749f, 2.269f)
                lineTo(4.762f, 2.295f)
                curveTo(4.761f, 2.296f, 4.759f, 2.297f, 4.757f, 2.297f)
                curveTo(4.737f, 2.308f, 4.721f, 2.316f, 4.749f, 2.269f)
                lineTo(4.686f, 2.144f)
                close()
                moveTo(4.722f, 2.153f)
                lineTo(4.734f, 2.156f)
                curveTo(4.733f, 2.156f, 4.731f, 2.155f, 4.729f, 2.154f)
                lineTo(4.722f, 2.153f)
                close()
                moveTo(4.38f, 2.117f)
                curveTo(4.38f, 2.129f, 4.384f, 2.136f, 4.391f, 2.14f)
                lineTo(4.387f, 2.135f)
                curveTo(4.383f, 2.126f, 4.38f, 2.12f, 4.38f, 2.117f)
                close()
            }
            path(
                fill = SolidColor(Color(0xFFFFE402)),
                pathFillType = PathFillType.EvenOdd
            ) {
                moveTo(11.867f, 1.741f)
                lineTo(12.123f, 2.695f)
                curveTo(12.123f, 2.695f, 12.126f, 2.912f, 11.88f, 2.912f)
                curveTo(11.635f, 2.912f, 11.623f, 2.695f, 11.623f, 2.695f)
                lineTo(11.867f, 1.741f)
                close()
                moveTo(14.031f, 5.387f)
                curveTo(14.031f, 6.63f, 13.083f, 7.637f, 11.913f, 7.637f)
                curveTo(10.743f, 7.637f, 9.794f, 6.63f, 9.794f, 5.387f)
                curveTo(9.794f, 4.145f, 10.743f, 3.137f, 11.913f, 3.137f)
                curveTo(13.083f, 3.137f, 14.031f, 4.145f, 14.031f, 5.387f)
                close()
                moveTo(12.863f, 2.888f)
                lineTo(12.898f, 1.9f)
                lineTo(12.386f, 2.742f)
                curveTo(12.386f, 2.742f, 12.334f, 2.953f, 12.568f, 3.025f)
                curveTo(12.803f, 3.096f, 12.863f, 2.888f, 12.863f, 2.888f)
                close()
                moveTo(13.838f, 2.368f)
                lineTo(13.516f, 3.302f)
                curveTo(13.516f, 3.302f, 13.397f, 3.484f, 13.194f, 3.347f)
                curveTo(12.991f, 3.21f, 13.102f, 3.023f, 13.102f, 3.023f)
                lineTo(13.838f, 2.368f)
                close()
                moveTo(14.023f, 3.902f)
                lineTo(14.604f, 3.102f)
                lineTo(13.709f, 3.514f)
                curveTo(13.709f, 3.514f, 13.548f, 3.66f, 13.702f, 3.851f)
                curveTo(13.856f, 4.041f, 14.023f, 3.902f, 14.023f, 3.902f)
                close()
                moveTo(15.132f, 4.049f)
                lineTo(14.332f, 4.63f)
                curveTo(14.332f, 4.63f, 14.131f, 4.71f, 14.043f, 4.481f)
                curveTo(13.955f, 4.253f, 14.153f, 4.163f, 14.153f, 4.163f)
                lineTo(15.132f, 4.049f)
                close()
                moveTo(14.43f, 5.426f)
                lineTo(15.365f, 5.105f)
                lineTo(14.395f, 4.928f)
                curveTo(14.395f, 4.928f, 14.179f, 4.956f, 14.197f, 5.2f)
                curveTo(14.214f, 5.445f, 14.43f, 5.426f, 14.43f, 5.426f)
                close()
                moveTo(15.288f, 6.185f)
                lineTo(14.3f, 6.22f)
                curveTo(14.3f, 6.22f, 14.088f, 6.174f, 14.143f, 5.935f)
                curveTo(14.198f, 5.696f, 14.412f, 5.733f, 14.412f, 5.733f)
                lineTo(15.288f, 6.185f)
                close()
                moveTo(13.954f, 6.938f)
                lineTo(14.908f, 7.194f)
                lineTo(14.203f, 6.506f)
                curveTo(14.203f, 6.506f, 14.009f, 6.408f, 13.887f, 6.62f)
                curveTo(13.764f, 6.832f, 13.954f, 6.938f, 13.954f, 6.938f)
                close()
                moveTo(14.26f, 8.042f)
                lineTo(13.422f, 7.519f)
                curveTo(13.422f, 7.519f, 13.272f, 7.362f, 13.451f, 7.195f)
                curveTo(13.63f, 7.028f, 13.787f, 7.178f, 13.787f, 7.178f)
                lineTo(14.26f, 8.042f)
                close()
                moveTo(12.752f, 7.909f)
                lineTo(13.4f, 8.655f)
                lineTo(13.201f, 7.69f)
                curveTo(13.201f, 7.69f, 13.094f, 7.5f, 12.874f, 7.608f)
                curveTo(12.654f, 7.715f, 12.752f, 7.909f, 12.752f, 7.909f)
                close()
                moveTo(12.405f, 8.977f)
                lineTo(12.003f, 8.074f)
                curveTo(12.003f, 8.074f, 11.966f, 7.86f, 12.208f, 7.822f)
                curveTo(12.45f, 7.783f, 12.496f, 7.996f, 12.496f, 7.996f)
                lineTo(12.405f, 8.977f)
                close()
                moveTo(11.249f, 7.996f)
                lineTo(11.353f, 8.979f)
                lineTo(11.743f, 8.074f)
                curveTo(11.743f, 8.074f, 11.764f, 7.857f, 11.522f, 7.819f)
                curveTo(11.28f, 7.781f, 11.249f, 7.996f, 11.249f, 7.996f)
                close()
                moveTo(10.356f, 8.66f)
                lineTo(10.545f, 7.69f)
                curveTo(10.545f, 7.69f, 10.637f, 7.493f, 10.858f, 7.601f)
                curveTo(11.078f, 7.708f, 10.994f, 7.909f, 10.994f, 7.909f)
                lineTo(10.356f, 8.66f)
                close()
                moveTo(9.959f, 7.178f)
                lineTo(9.495f, 8.051f)
                lineTo(10.324f, 7.519f)
                curveTo(10.324f, 7.519f, 10.463f, 7.351f, 10.284f, 7.184f)
                curveTo(10.104f, 7.017f, 9.959f, 7.178f, 9.959f, 7.178f)
                close()
                moveTo(8.843f, 7.205f)
                lineTo(9.542f, 6.506f)
                curveTo(9.542f, 6.506f, 9.729f, 6.395f, 9.851f, 6.607f)
                curveTo(9.974f, 6.819f, 9.792f, 6.938f, 9.792f, 6.938f)
                lineTo(8.843f, 7.205f)
                close()
                moveTo(9.333f, 5.733f)
                lineTo(8.461f, 6.197f)
                lineTo(9.446f, 6.22f)
                curveTo(9.446f, 6.22f, 9.654f, 6.159f, 9.599f, 5.92f)
                curveTo(9.544f, 5.681f, 9.333f, 5.733f, 9.333f, 5.733f)
                close()
                moveTo(8.38f, 5.117f)
                lineTo(9.351f, 4.928f)
                curveTo(9.351f, 4.928f, 9.567f, 4.94f, 9.55f, 5.185f)
                curveTo(9.533f, 5.429f, 9.316f, 5.426f, 9.316f, 5.426f)
                lineTo(8.38f, 5.117f)
                close()
                moveTo(9.593f, 4.163f)
                lineTo(8.609f, 4.06f)
                lineTo(9.414f, 4.63f)
                curveTo(9.414f, 4.63f, 9.621f, 4.696f, 9.708f, 4.467f)
                curveTo(9.796f, 4.238f, 9.593f, 4.163f, 9.593f, 4.163f)
                close()
                moveTo(9.134f, 3.112f)
                lineTo(10.037f, 3.514f)
                curveTo(10.037f, 3.514f, 10.208f, 3.648f, 10.053f, 3.839f)
                curveTo(9.899f, 4.029f, 9.723f, 3.902f, 9.723f, 3.902f)
                lineTo(9.134f, 3.112f)
                close()
                moveTo(10.644f, 3.023f)
                lineTo(9.898f, 2.375f)
                lineTo(10.23f, 3.302f)
                curveTo(10.23f, 3.302f, 10.361f, 3.475f, 10.564f, 3.338f)
                curveTo(10.767f, 3.201f, 10.644f, 3.023f, 10.644f, 3.023f)
                close()
                moveTo(10.836f, 1.904f)
                lineTo(11.36f, 2.742f)
                curveTo(11.36f, 2.742f, 11.426f, 2.948f, 11.192f, 3.02f)
                curveTo(10.958f, 3.092f, 10.882f, 2.888f, 10.882f, 2.888f)
                lineTo(10.836f, 1.904f)
                close()
            }
            path(
                fill = SolidColor(Color(0xFFFFE402)),
                pathFillType = PathFillType.EvenOdd
            ) {
                moveTo(7.638f, 6.67f)
                curveTo(7.63f, 6.637f, 7.622f, 6.605f, 7.615f, 6.574f)
                lineTo(7.658f, 6.662f)
                lineTo(7.638f, 6.67f)
                close()
                moveTo(7.698f, 6.876f)
                curveTo(7.675f, 6.804f, 7.655f, 6.736f, 7.638f, 6.67f)
                lineTo(7.37f, 6.777f)
                lineTo(7.41f, 6.876f)
                horizontalLineTo(7.381f)
                lineTo(7.37f, 6.882f)
                curveTo(7.354f, 6.8f, 7.346f, 6.723f, 7.346f, 6.649f)
                verticalLineTo(6.032f)
                lineTo(7.615f, 6.574f)
                curveTo(7.581f, 6.423f, 7.563f, 6.291f, 7.563f, 6.176f)
                verticalLineTo(5.407f)
                lineTo(7.875f, 6.186f)
                lineTo(7.579f, 6.278f)
                lineTo(7.695f, 6.649f)
                horizontalLineTo(7.69f)
                lineTo(7.658f, 6.662f)
                lineTo(7.769f, 6.884f)
                lineTo(7.875f, 7.223f)
                curveTo(7.775f, 7.041f, 7.725f, 6.92f, 7.725f, 6.876f)
                horizontalLineTo(7.698f)
                close()
                moveTo(8.04f, 7.743f)
                curveTo(7.891f, 7.413f, 7.777f, 7.125f, 7.698f, 6.876f)
                horizontalLineTo(7.41f)
                lineTo(7.703f, 7.61f)
                lineTo(7.594f, 7.494f)
                curveTo(7.481f, 7.266f, 7.406f, 7.064f, 7.37f, 6.882f)
                lineTo(7.132f, 7f)
                lineTo(7.084f, 6.95f)
                verticalLineTo(7.024f)
                lineTo(7.073f, 7.029f)
                lineTo(7.084f, 7.051f)
                verticalLineTo(7.135f)
                curveTo(7.053f, 7.037f, 7.037f, 6.952f, 7.037f, 6.876f)
                verticalLineTo(5.412f)
                lineTo(7.346f, 6.032f)
                verticalLineTo(4.861f)
                lineTo(7.563f, 5.407f)
                verticalLineTo(3.927f)
                lineTo(8.433f, 6.704f)
                lineTo(8.372f, 6.724f)
                curveTo(8.291f, 6.483f, 8.251f, 6.299f, 8.251f, 6.176f)
                horizontalLineTo(7.907f)
                lineTo(7.875f, 6.186f)
                lineTo(8.122f, 6.805f)
                lineTo(8.062f, 6.825f)
                curveTo(8.043f, 6.756f, 8.033f, 6.697f, 8.033f, 6.649f)
                horizontalLineTo(7.695f)
                lineTo(7.769f, 6.884f)
                lineTo(8.152f, 7.656f)
                lineTo(8.137f, 7.663f)
                curveTo(8.028f, 7.492f, 7.941f, 7.344f, 7.875f, 7.223f)
                lineTo(8.026f, 7.705f)
                lineTo(8.137f, 7.663f)
                lineTo(8.152f, 7.687f)
                lineTo(8.04f, 7.743f)
                close()
                moveTo(8.159f, 7.698f)
                lineTo(8.04f, 7.743f)
                lineTo(8.04f, 7.743f)
                lineTo(7.896f, 7.815f)
                lineTo(7.703f, 7.61f)
                lineTo(7.795f, 7.84f)
                curveTo(7.784f, 7.83f, 7.777f, 7.824f, 7.774f, 7.821f)
                curveTo(7.706f, 7.707f, 7.646f, 7.598f, 7.594f, 7.494f)
                lineTo(7.132f, 7f)
                lineTo(7.084f, 7.024f)
                verticalLineTo(7.051f)
                lineTo(7.465f, 7.819f)
                horizontalLineTo(7.428f)
                lineTo(7.425f, 7.821f)
                curveTo(7.256f, 7.541f, 7.142f, 7.317f, 7.084f, 7.135f)
                verticalLineTo(7.637f)
                lineTo(5.719f, 6.664f)
                lineTo(7.458f, 8.734f)
                curveTo(8.013f, 9.395f, 8.698f, 9.903f, 9.508f, 10.257f)
                lineTo(7.933f, 10.223f)
                lineTo(9.534f, 10.675f)
                lineTo(8.706f, 11.284f)
                lineTo(10.136f, 10.845f)
                lineTo(10.526f, 10.955f)
                curveTo(11.051f, 11.103f, 11.343f, 11.252f, 11.362f, 11.297f)
                lineTo(11.436f, 11.471f)
                lineTo(11.622f, 11.502f)
                curveTo(12.031f, 11.57f, 12.785f, 11.464f, 13.756f, 11.248f)
                curveTo(14.086f, 11.175f, 14.417f, 11.094f, 14.673f, 11.025f)
                curveTo(14.781f, 10.996f, 14.865f, 10.972f, 14.912f, 10.956f)
                lineTo(14.93f, 10.95f)
                curveTo(14.936f, 10.948f, 14.943f, 10.945f, 14.957f, 10.94f)
                lineTo(14.957f, 10.94f)
                lineTo(14.968f, 10.935f)
                curveTo(14.976f, 10.932f, 14.983f, 10.928f, 15.009f, 10.914f)
                lineTo(15.009f, 10.914f)
                curveTo(15.041f, 10.909f, 15.064f, 10.906f, 15.079f, 10.894f)
                curveTo(15.122f, 10.859f, 15.106f, 10.752f, 15.047f, 10.35f)
                lineTo(15.047f, 10.35f)
                lineTo(15.047f, 10.35f)
                curveTo(14.776f, 10.277f, 14.739f, 10.267f, 14.729f, 10.28f)
                curveTo(14.727f, 10.282f, 14.726f, 10.284f, 14.725f, 10.287f)
                curveTo(14.632f, 10.307f, 14.487f, 10.304f, 14.294f, 10.28f)
                curveTo(15.91f, 9.485f, 16.972f, 8.689f, 17.48f, 7.869f)
                lineTo(18.411f, 6.371f)
                lineTo(17.847f, 6.782f)
                lineTo(18.05f, 6.129f)
                lineTo(17.247f, 6.645f)
                curveTo(17.35f, 6.508f, 17.43f, 6.372f, 17.487f, 6.235f)
                lineTo(18.092f, 4.773f)
                lineTo(17.137f, 5.664f)
                lineTo(17.655f, 3.957f)
                lineTo(16.426f, 5.603f)
                lineTo(11.395f, 9.305f)
                lineTo(11.317f, 9.287f)
                curveTo(10.078f, 9f, 9.208f, 8.125f, 8.691f, 6.62f)
                lineTo(8.433f, 6.704f)
                lineTo(8.436f, 6.715f)
                lineTo(8.375f, 6.734f)
                lineTo(8.372f, 6.724f)
                lineTo(8.122f, 6.805f)
                lineTo(8.126f, 6.816f)
                lineTo(8.065f, 6.835f)
                lineTo(8.062f, 6.825f)
                lineTo(8.037f, 6.833f)
                curveTo(8.121f, 7.104f, 8.212f, 7.359f, 8.311f, 7.596f)
                lineTo(8.152f, 7.656f)
                lineTo(8.164f, 7.681f)
                lineTo(8.152f, 7.687f)
                lineTo(8.159f, 7.698f)
                close()
                moveTo(8.171f, 7.694f)
                lineTo(8.159f, 7.698f)
                lineTo(8.184f, 7.736f)
                lineTo(7.937f, 7.86f)
                lineTo(7.896f, 7.815f)
                lineTo(7.815f, 7.856f)
                curveTo(7.807f, 7.85f, 7.8f, 7.844f, 7.795f, 7.84f)
                lineTo(7.803f, 7.862f)
                lineTo(7.815f, 7.856f)
                curveTo(7.829f, 7.866f, 7.847f, 7.879f, 7.869f, 7.894f)
                lineTo(7.83f, 7.914f)
                curveTo(7.81f, 7.882f, 7.792f, 7.852f, 7.774f, 7.821f)
                lineTo(7.772f, 7.819f)
                horizontalLineTo(7.465f)
                lineTo(7.535f, 7.958f)
                lineTo(7.49f, 7.926f)
                curveTo(7.467f, 7.89f, 7.446f, 7.855f, 7.425f, 7.821f)
                lineTo(7.39f, 7.855f)
                lineTo(7.084f, 7.637f)
                verticalLineTo(7.819f)
                curveTo(7.084f, 8.144f, 7.313f, 8.39f, 7.706f, 8.592f)
                lineTo(7.521f, 8.793f)
                lineTo(9.578f, 10.258f)
                lineTo(9.508f, 10.257f)
                curveTo(9.575f, 10.286f, 9.644f, 10.314f, 9.713f, 10.342f)
                lineTo(9.891f, 10.412f)
                lineTo(9.534f, 10.675f)
                lineTo(10.136f, 10.845f)
                lineTo(10.616f, 10.697f)
                lineTo(12.324f, 11.37f)
                lineTo(11.773f, 10.978f)
                curveTo(11.84f, 10.977f, 11.906f, 10.976f, 11.969f, 10.975f)
                curveTo(11.942f, 10.926f, 11.908f, 10.879f, 11.867f, 10.835f)
                curveTo(11.816f, 10.833f, 11.772f, 10.83f, 11.735f, 10.824f)
                lineTo(11.716f, 10.937f)
                lineTo(11.14f, 10.527f)
                curveTo(11.361f, 10.451f, 11.575f, 10.371f, 11.782f, 10.288f)
                curveTo(12.635f, 10.279f, 13.146f, 10.233f, 13.222f, 10.177f)
                lineTo(13.353f, 10.079f)
                lineTo(13.512f, 10.12f)
                curveTo(13.665f, 10.159f, 13.806f, 10.192f, 13.934f, 10.218f)
                lineTo(14.043f, 10.401f)
                curveTo(14.128f, 10.361f, 14.212f, 10.32f, 14.294f, 10.28f)
                curveTo(14.274f, 10.277f, 14.253f, 10.274f, 14.231f, 10.271f)
                lineTo(17.391f, 7.966f)
                lineTo(17.127f, 7.72f)
                curveTo(17.461f, 7.548f, 17.679f, 7.322f, 17.77f, 7.031f)
                lineTo(17.847f, 6.782f)
                lineTo(17.507f, 7.03f)
                lineTo(17.441f, 6.929f)
                lineTo(17.113f, 6.827f)
                curveTo(17.083f, 6.924f, 16.984f, 7.022f, 16.809f, 7.112f)
                curveTo(16.985f, 6.955f, 17.131f, 6.8f, 17.247f, 6.645f)
                lineTo(16.751f, 6.964f)
                lineTo(17.404f, 6.355f)
                lineTo(16.996f, 6.073f)
                curveTo(17.032f, 5.992f, 17.061f, 5.913f, 17.085f, 5.835f)
                lineTo(17.137f, 5.664f)
                lineTo(16.907f, 5.878f)
                lineTo(16.565f, 5.705f)
                lineTo(16.723f, 5.384f)
                lineTo(16.426f, 5.603f)
                lineTo(15.723f, 6.545f)
                lineTo(15.483f, 6.344f)
                curveTo(14.841f, 7.648f, 13.685f, 8.683f, 12.004f, 9.446f)
                lineTo(11.395f, 9.305f)
                lineTo(11.221f, 9.433f)
                lineTo(11.239f, 9.278f)
                curveTo(10.093f, 9.278f, 9.248f, 8.428f, 8.694f, 6.63f)
                lineTo(8.436f, 6.715f)
                lineTo(8.682f, 7.499f)
                lineTo(8.436f, 7.593f)
                lineTo(8.421f, 7.554f)
                lineTo(8.667f, 7.461f)
                curveTo(8.541f, 7.181f, 8.444f, 6.938f, 8.375f, 6.734f)
                lineTo(8.126f, 6.816f)
                lineTo(8.421f, 7.554f)
                lineTo(8.4f, 7.562f)
                lineTo(8.416f, 7.554f)
                curveTo(8.233f, 7.256f, 8.117f, 7.013f, 8.065f, 6.835f)
                lineTo(8.041f, 6.843f)
                curveTo(8.131f, 7.106f, 8.232f, 7.353f, 8.343f, 7.584f)
                lineTo(8.311f, 7.596f)
                lineTo(8.315f, 7.605f)
                lineTo(8.164f, 7.681f)
                lineTo(8.171f, 7.694f)
                close()
                moveTo(8.327f, 7.634f)
                lineTo(8.171f, 7.694f)
                lineTo(8.19f, 7.733f)
                lineTo(8.184f, 7.736f)
                lineTo(8.207f, 7.772f)
                lineTo(7.978f, 7.903f)
                lineTo(7.937f, 7.86f)
                lineTo(7.869f, 7.894f)
                curveTo(7.887f, 7.905f, 7.907f, 7.918f, 7.93f, 7.931f)
                lineTo(7.69f, 8.069f)
                lineTo(7.535f, 7.958f)
                lineTo(7.612f, 8.113f)
                lineTo(7.69f, 8.069f)
                lineTo(7.726f, 8.094f)
                lineTo(7.632f, 8.148f)
                curveTo(7.581f, 8.071f, 7.534f, 7.997f, 7.49f, 7.926f)
                lineTo(7.39f, 7.855f)
                lineTo(7.177f, 8.054f)
                lineTo(7.618f, 8.525f)
                lineTo(7.869f, 8.289f)
                lineTo(7.904f, 8.221f)
                lineTo(9.024f, 9.019f)
                lineTo(9.438f, 9.461f)
                curveTo(8.874f, 9.165f, 8.39f, 8.775f, 7.984f, 8.292f)
                lineTo(7.706f, 8.592f)
                lineTo(7.713f, 8.596f)
                lineTo(9.466f, 9.491f)
                lineTo(9.438f, 9.461f)
                curveTo(9.607f, 9.55f, 9.782f, 9.63f, 9.965f, 9.702f)
                lineTo(9.662f, 10.26f)
                lineTo(9.578f, 10.258f)
                lineTo(9.639f, 10.302f)
                lineTo(9.662f, 10.26f)
                lineTo(10.085f, 10.269f)
                lineTo(9.891f, 10.412f)
                lineTo(10.616f, 10.697f)
                lineTo(10.641f, 10.689f)
                curveTo(10.811f, 10.637f, 10.977f, 10.583f, 11.14f, 10.527f)
                lineTo(11.016f, 10.438f)
                lineTo(11.218f, 10.289f)
                curveTo(11.42f, 10.29f, 11.608f, 10.29f, 11.782f, 10.288f)
                curveTo(12.036f, 10.186f, 12.281f, 10.078f, 12.516f, 9.966f)
                horizontalLineTo(13.783f)
                lineTo(13.934f, 10.218f)
                curveTo(13.962f, 10.224f, 13.991f, 10.229f, 14.018f, 10.235f)
                lineTo(14.098f, 10.368f)
                lineTo(14.231f, 10.271f)
                curveTo(14.165f, 10.261f, 14.094f, 10.249f, 14.018f, 10.235f)
                lineTo(13.858f, 9.966f)
                horizontalLineTo(14.244f)
                lineTo(13.796f, 9.862f)
                lineTo(13.748f, 9.78f)
                curveTo(15.077f, 9.148f, 16.018f, 8.528f, 16.568f, 7.932f)
                curveTo(16.78f, 7.873f, 16.966f, 7.803f, 17.127f, 7.72f)
                lineTo(17.012f, 7.614f)
                lineTo(17.627f, 7.218f)
                lineTo(17.507f, 7.03f)
                lineTo(16.469f, 7.787f)
                lineTo(16.339f, 7.485f)
                curveTo(16.514f, 7.359f, 16.671f, 7.235f, 16.809f, 7.112f)
                curveTo(16.711f, 7.162f, 16.588f, 7.209f, 16.441f, 7.253f)
                lineTo(16.751f, 6.964f)
                lineTo(15.81f, 7.569f)
                curveTo(16.396f, 7.028f, 16.793f, 6.532f, 16.996f, 6.073f)
                lineTo(16.955f, 6.044f)
                lineTo(17.031f, 5.941f)
                lineTo(16.907f, 5.878f)
                lineTo(16.116f, 6.616f)
                lineTo(16.565f, 5.705f)
                lineTo(16.427f, 5.636f)
                curveTo(16.343f, 5.913f, 16.134f, 6.239f, 15.799f, 6.608f)
                lineTo(15.723f, 6.545f)
                lineTo(15.299f, 7.113f)
                lineTo(15.405f, 7.208f)
                lineTo(12.277f, 9.51f)
                lineTo(12.004f, 9.446f)
                curveTo(11.742f, 9.565f, 11.468f, 9.677f, 11.181f, 9.783f)
                lineTo(11.221f, 9.433f)
                lineTo(10.695f, 9.82f)
                curveTo(9.686f, 9.459f, 8.91f, 8.728f, 8.372f, 7.642f)
                lineTo(8.442f, 7.607f)
                lineTo(8.436f, 7.593f)
                lineTo(8.361f, 7.621f)
                lineTo(8.346f, 7.589f)
                lineTo(8.4f, 7.562f)
                lineTo(8.343f, 7.584f)
                lineTo(8.346f, 7.589f)
                lineTo(8.315f, 7.605f)
                lineTo(8.327f, 7.634f)
                close()
                moveTo(8.338f, 7.659f)
                lineTo(8.19f, 7.733f)
                lineTo(8.227f, 7.807f)
                lineTo(8.007f, 7.934f)
                lineTo(7.978f, 7.903f)
                lineTo(7.93f, 7.931f)
                curveTo(7.942f, 7.939f, 7.956f, 7.946f, 7.971f, 7.954f)
                lineTo(7.726f, 8.094f)
                lineTo(7.904f, 8.221f)
                lineTo(8.025f, 7.983f)
                curveTo(8.006f, 7.973f, 7.987f, 7.964f, 7.971f, 7.954f)
                lineTo(8.007f, 7.934f)
                lineTo(9.024f, 9.019f)
                lineTo(10.426f, 10.018f)
                lineTo(10.085f, 10.269f)
                lineTo(10.564f, 10.279f)
                lineTo(10.744f, 10.638f)
                lineTo(11.016f, 10.438f)
                lineTo(10.799f, 10.284f)
                curveTo(10.944f, 10.286f, 11.084f, 10.288f, 11.218f, 10.289f)
                lineTo(11.658f, 9.966f)
                horizontalLineTo(12.516f)
                curveTo(12.7f, 9.877f, 12.879f, 9.785f, 13.051f, 9.689f)
                lineTo(13.71f, 9.842f)
                lineTo(13.783f, 9.966f)
                horizontalLineTo(13.858f)
                lineTo(13.796f, 9.862f)
                lineTo(13.71f, 9.842f)
                lineTo(13.693f, 9.813f)
                lineTo(16.118f, 8.044f)
                lineTo(16.423f, 7.97f)
                curveTo(16.472f, 7.958f, 16.521f, 7.945f, 16.568f, 7.932f)
                curveTo(16.591f, 7.906f, 16.615f, 7.88f, 16.637f, 7.855f)
                lineTo(17.012f, 7.614f)
                lineTo(16.896f, 7.507f)
                curveTo(16.825f, 7.622f, 16.739f, 7.738f, 16.637f, 7.855f)
                lineTo(16.528f, 7.925f)
                lineTo(16.469f, 7.787f)
                lineTo(16.118f, 8.044f)
                lineTo(14.873f, 8.346f)
                curveTo(15.012f, 8.207f, 15.144f, 8.064f, 15.268f, 7.917f)
                lineTo(15.667f, 7.661f)
                lineTo(15.803f, 7.839f)
                curveTo(15.997f, 7.72f, 16.176f, 7.602f, 16.339f, 7.485f)
                lineTo(16.298f, 7.387f)
                lineTo(16.441f, 7.253f)
                curveTo(16.385f, 7.27f, 16.325f, 7.286f, 16.261f, 7.301f)
                lineTo(16.298f, 7.387f)
                lineTo(15.857f, 7.798f)
                lineTo(15.724f, 7.624f)
                lineTo(15.807f, 7.571f)
                lineTo(15.807f, 7.571f)
                lineTo(15.81f, 7.569f)
                lineTo(15.807f, 7.571f)
                lineTo(15.645f, 7.424f)
                curveTo(15.657f, 7.407f, 15.669f, 7.389f, 15.681f, 7.372f)
                lineTo(15.85f, 7.524f)
                lineTo(16.955f, 6.044f)
                lineTo(16.851f, 5.972f)
                curveTo(16.74f, 6.242f, 16.445f, 6.558f, 15.965f, 6.906f)
                curveTo(16.012f, 6.821f, 16.057f, 6.735f, 16.1f, 6.648f)
                lineTo(16.116f, 6.616f)
                lineTo(15.97f, 6.752f)
                lineTo(15.799f, 6.608f)
                curveTo(15.666f, 6.754f, 15.514f, 6.907f, 15.341f, 7.066f)
                lineTo(15.457f, 7.17f)
                lineTo(15.405f, 7.208f)
                lineTo(15.444f, 7.243f)
                lineTo(15.388f, 7.295f)
                lineTo(15.569f, 7.532f)
                curveTo(15.474f, 7.664f, 15.374f, 7.792f, 15.268f, 7.917f)
                lineTo(14.436f, 8.452f)
                lineTo(14.873f, 8.346f)
                curveTo(14.365f, 8.851f, 13.758f, 9.298f, 13.051f, 9.689f)
                lineTo(12.277f, 9.51f)
                lineTo(11.658f, 9.966f)
                horizontalLineTo(11.239f)
                curveTo(11.077f, 9.966f, 10.919f, 9.953f, 10.767f, 9.928f)
                curveTo(10.809f, 9.914f, 10.851f, 9.899f, 10.893f, 9.885f)
                curveTo(10.981f, 9.912f, 11.07f, 9.935f, 11.161f, 9.957f)
                lineTo(11.181f, 9.783f)
                curveTo(11.087f, 9.818f, 10.99f, 9.852f, 10.893f, 9.885f)
                curveTo(10.826f, 9.865f, 10.76f, 9.843f, 10.695f, 9.82f)
                lineTo(10.595f, 9.894f)
                curveTo(9.627f, 9.668f, 8.873f, 8.911f, 8.338f, 7.659f)
                close()
                moveTo(8.338f, 7.659f)
                lineTo(8.372f, 7.642f)
                lineTo(8.361f, 7.621f)
                lineTo(8.327f, 7.634f)
                lineTo(8.338f, 7.659f)
                close()
                moveTo(10.444f, 10.031f)
                lineTo(10.426f, 10.018f)
                lineTo(10.595f, 9.894f)
                curveTo(10.652f, 9.907f, 10.709f, 9.918f, 10.767f, 9.928f)
                curveTo(10.661f, 9.963f, 10.553f, 9.997f, 10.444f, 10.031f)
                close()
                moveTo(15.61f, 7.474f)
                lineTo(15.645f, 7.424f)
                lineTo(15.45f, 7.249f)
                lineTo(15.506f, 7.214f)
                lineTo(15.681f, 7.372f)
                curveTo(15.783f, 7.22f, 15.877f, 7.065f, 15.965f, 6.906f)
                curveTo(15.828f, 7.006f, 15.675f, 7.109f, 15.506f, 7.214f)
                lineTo(15.49f, 7.2f)
                lineTo(15.769f, 6.94f)
                lineTo(15.995f, 6.773f)
                lineTo(15.97f, 6.752f)
                lineTo(15.769f, 6.94f)
                lineTo(15.457f, 7.17f)
                lineTo(15.49f, 7.2f)
                lineTo(15.444f, 7.243f)
                lineTo(15.45f, 7.249f)
                lineTo(15.443f, 7.254f)
                lineTo(15.61f, 7.474f)
                close()
                moveTo(15.61f, 7.474f)
                lineTo(15.724f, 7.624f)
                lineTo(15.667f, 7.661f)
                lineTo(15.569f, 7.532f)
                curveTo(15.583f, 7.513f, 15.597f, 7.493f, 15.61f, 7.474f)
                close()
                moveTo(10.444f, 10.031f)
                lineTo(10.799f, 10.284f)
                curveTo(10.742f, 10.283f, 10.685f, 10.281f, 10.627f, 10.28f)
                lineTo(10.564f, 10.279f)
                lineTo(10.439f, 10.032f)
                lineTo(10.444f, 10.031f)
                close()
                moveTo(11.716f, 10.937f)
                lineTo(11.709f, 10.978f)
                lineTo(11.773f, 10.978f)
                lineTo(11.716f, 10.937f)
                close()
                moveTo(13.631f, 10.729f)
                lineTo(13.531f, 10.594f)
                curveTo(13.481f, 10.605f, 13.431f, 10.616f, 13.382f, 10.626f)
                lineTo(13.341f, 10.786f)
                curveTo(13.381f, 10.796f, 13.421f, 10.806f, 13.459f, 10.816f)
                curveTo(13.531f, 10.79f, 13.588f, 10.761f, 13.631f, 10.729f)
                close()
            }
        }
    }.build()
}

@Preview
@Composable
private fun KazakhstanPreview() {
    Box(modifier = Modifier.padding(12.dp)) {
        Image(
            imageVector = FlagIcons.Medium.Kazakhstan,
            contentDescription = "Kazakhstan Flag"
        )
    }
}
